(function Module() {
	'use strict';

	mySynch.controller('FertilityCodesLactation1Controller', [
		'$scope',
		'MySynchFactory',
		'FertilityFactory',
		'ViewAuthorizationFactory',
		'mySynchEnumerationService',
		'performanceMetricsService',
		'performanceContextService',
		function FertilityCodesLactation1Controller($s, MSF, fertility, viewAuth,mySynchEnumSvc, perfMetricSvc, perfContextSvc) {
			
			$s.performanceContext = null;
			
			$s.canUpdate = false;
			
			// deregistration functions
			var deregOnPermissionChanged = null;
			var deregOnHerdFertilityProgramChanged = null;

			deregOnPermissionChanged = $s.$on('permission:changed', function onPermissionChanged() {
				checkPermissions();
			});

			function checkPermissions() {
				$s.canUpdate = viewAuth.hasPermission(mySynchEnumSvc.getMySynchEnumeration('Permission','LACTATION_1_UPDATE'));
			}

			function doneLoading() {
				$s.loading = false;
				$s.$apply();
			}

			function loadProtocolsOnChange() {
				perfMetricSvc.startTiming('Page:FertilityLactation1OnHerdFertilityProgramChanged:Render');
				perfMetricSvc.startTiming('Page:FertilityLactation1OnHerdFertilityProgramChanged:Build');
				$s.loading = true;
				fertility.resetAll();
				fertility.load.planAndProtocols($s.parityTypeId, $s.performanceContext, () => {
					perfMetricSvc.endTiming("page",'Page:FertilityLactation1OnHerdFertilityProgramChanged:Build', $s.performanceContext);
					doneLoading();
					perfMetricSvc.endTiming("page",'Page:FertilityLactation1OnHerdFertilityProgramChanged:Render', $s.performanceContext);
				});
			}

			$s.loading = true;
			$s.MSF = MSF;
			$s.fertility = fertility;
			$s.parityTypeId = 2; // parity 2 is lactation 1 and is the parityTypeId for this page

			deregOnHerdFertilityProgramChanged = $s.$on('herdFertilityProgram:changed', loadProtocolsOnChange);

			$s.$on('$destroy', function onDestroy() {
				if (deregOnPermissionChanged) {
					deregOnPermissionChanged();
				}

				if (deregOnHerdFertilityProgramChanged) {
					deregOnHerdFertilityProgramChanged();
				}

				$s.performanceContext = null;
			});

			MSF.ready(function whenMsfReady() {
				$s.performanceContext = perfContextSvc.createPerformanceContext(_.get(MSF.getActiveHerd(),'herdId', null));
				perfMetricSvc.startTiming('Page:FertilityLactation1:Render');
				perfMetricSvc.startTiming('Page:FertilityLactation1:Build');
				checkPermissions();
				fertility.resetAll();

				perfMetricSvc.startTiming('Page:FertilityLactation1HerdFromDb:Request');
				fertility.load.herdFromDb($s.performanceContext, function herdLoaded() {
					perfMetricSvc.endTiming("page",'Page:FertilityLactation1HerdFromDb:Request', $s.performanceContext);
					perfMetricSvc.startTiming('Page:FertilityLactation1PlanAndProtocols:Request');
					fertility.load.planAndProtocols($s.parityTypeId, $s.performanceContext, () => {
						perfMetricSvc.endTiming("page",'Page:FertilityLactation1PlanAndProtocols:Request', $s.performanceContext);
						doneLoading();
						perfMetricSvc.endTiming("page",'Page:FertilityLactation1:Build', $s.performanceContext);
						perfMetricSvc.markPageReady('Page:FertilityLactation1:Render', $s.performanceContext);
					});
				});
			});
		}
	]);
})();
